import { render, staticRenderFns } from "./set-score.vue?vue&type=template&id=dd716d50&scoped=true"
import script from "./set-score.vue?vue&type=script&lang=ts"
export * from "./set-score.vue?vue&type=script&lang=ts"
import style0 from "./set-score.vue?vue&type=style&index=0&id=dd716d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd716d50",
  null
  
)

export default component.exports